import { HighlightVariant } from './highlight-layer/HighlightLayer.props';
import { PageData, PDFCitationPayload, Rect } from './pdf-utils/constants';
import { CitationReferenceData } from '../../../services/reference-generator/types';

export enum PDFViewerViewMode {
  DOCUMENT = 'DOCUMENT',
  THUMBNAIL = 'THUMBNAIL',
}

export interface SearchHighlight {
  pageNumber: number;
  wordIds: number[];
  rects: Rect[];
}

export interface PDFViewerProps {
  src?: string;
  base64Content?: string;
  allowPageSelection?: boolean;
  selectedPages?: Set<number>;
  onPageToggle?: (pageNumber: number) => void;
  viewMode: PDFViewerViewMode;
  jsonData?: PageData[];
  activeCitation?: CitationReferenceData;
  /** Highlight color for the active citation; 'ai' for review-mode jumps. Defaults to 'citation'. */
  activeCitationVariant?: HighlightVariant;
  onCitationPushed?: (payload: PDFCitationPayload) => void;
  searchHighlight?: SearchHighlight | null;
}
